import { createAuthClient } from 'better-auth/react';
import {
  organizationClient,
  magicLinkClient,
} from 'better-auth/client/plugins';

// Use VITE_ prefix for client-side env vars in Vite/React Router
// This should point to the backend auth server (node-api)
const API_URL = import.meta.env.VITE_NODE_API_URL;

export const authClient = createAuthClient({
  baseURL: API_URL, // Full URL to your backend
  plugins: [organizationClient(), magicLinkClient()],
  // Optional: Configure default redirects
  socialProviders: {},
  // You can also configure success/error callbacks here
});

// Export typed hooks
export const {
  useSession,
  useListOrganizations,
  useActiveOrganization,
  signIn,
  signUp,
  signOut,
  organization,
  requestPasswordReset,
  resetPassword,
} = authClient;
